import { StandardAsset } from '$components/Asset';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

import FadeInSection from '../FadeInSection/FadeInSection';
import { IMedia } from './';

export function Media(props: IMedia & HTMLAttributes<HTMLElement>) {
  const { assets } = props;

  return (
    <FadeInSection>
      <div className="flex flex-row justify-center">
        <div className={`grid-standard `}>
          <div className={` col-span-4 lg:col-span-12`}>
            <StandardAsset
              assets={assets}
              sizes="100vw"
              className={cn('rounded-[2.5rem] overflow-hidden')}
            />
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}
